import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function convertToCSV(data, headers) {
        const headerRow = headers.map((h) => h.field).join(",") + "\n";

        const rows = data
            .map((row) => headers.map((h) => `"${row[h.key] ?? ""}"`).join(","))
            .join("\n");

        return headerRow + rows;
    }

export function generateSecurePassword() {
	const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	const lower = "abcdefghijklmnopqrstuvwxyz";
	const numbers = "0123456789";
	const special = "!@#$%^&*()_+-=[]{}|;:,.<>?";

	const all = upper + lower + numbers + special;

	const getRandom = (str) => str[Math.floor(Math.random() * str.length)];

	// initialize the password array with at least one character type
	let password = [
		getRandom(upper),
		getRandom(lower),
		getRandom(numbers),
		getRandom(special),
	];

	// Fill the remaining array with random characters
	for (let i = password.length; i < 8; i++) {
		password.push(getRandom(all));
	}

	// Shuffle the password to randomize it and remove predictable patterns
	password = password
		.map((value) => ({ value, sort: Math.random() }))
		.sort((a, b) => a.sort - b.sort)
		.map(({ value }) => value)
		.join("");

	return password;
}
  
